<section class="platform-dashboard">
  <app-dashboard-task-reminder-banner />

  <div class="stat-rows">
    @if (loading()) {
      @for (row of [1, 2]; track row) {
        <div class="stat-row">
          <h2 class="stat-row__title">
            <app-admin-skeleton variant="title" />
          </h2>
          <div class="stat-row__grid">
            @for (card of [1, 2, 3, 4, 5]; track card) {
              <app-admin-skeleton variant="card" />
            }
          </div>
        </div>
      }
    } @else if (error()) {
      <div class="cg-admin-alert cg-admin-alert--error">{{ error() }}</div>
    } @else if (stats(); as data) {
      <div class="stat-row">
        <h2 class="stat-row__title">Leads</h2>
        <div class="stat-row__grid">
          <app-admin-stat-card
            title="Total Leads"
            [value]="data.leads.total"
            subtext="All active leads"
            icon="users"
            tint="blue"
            routerLink="/platform/leads"
            [queryParams]="{ includeEnrolled: 'true' }"
          />
          <app-admin-stat-card
            title="New Leads Today"
            [value]="data.leads.newToday"
            subtext="Created today (UTC)"
            icon="user-plus"
            tint="amber"
            routerLink="/platform/leads"
            [queryParams]="{ createdToday: 'true', includeEnrolled: 'true' }"
          />
          <app-admin-stat-card
            title="Qualified Leads"
            [value]="data.leads.qualified"
            subtext="Status: Qualified"
            icon="badge-check"
            tint="violet"
            routerLink="/platform/leads"
            [queryParams]="{ statusCode: 'QUALIFIED' }"
          />
          <app-admin-stat-card
            title="Enrolled"
            [value]="data.leads.enrolled"
            subtext="Converted to applicants"
            icon="graduation-cap"
            tint="green"
            routerLink="/platform/leads"
            [queryParams]="{ statusCode: 'ENROLLED' }"
          />
          <app-admin-stat-card
            title="Conv. Rate"
            [value]="formatRate(data.leads.conversionRate)"
            subtext="View enrolled leads"
            icon="bar-chart-3"
            tint="slate"
            routerLink="/platform/leads"
            [queryParams]="{ statusCode: 'ENROLLED' }"
          />
        </div>
      </div>

      <div class="stat-row">
        <h2 class="stat-row__title">Applicants</h2>
        <div class="stat-row__grid">
          <app-admin-stat-card
            title="Total Applicants"
            [value]="data.applicants.total"
            subtext="All active applicants"
            icon="briefcase"
            tint="blue"
            routerLink="/platform/applicants"
          />
          <app-admin-stat-card
            title="New Applicants Today"
            [value]="data.applicants.newToday"
            subtext="Created today (UTC)"
            icon="user-plus"
            tint="amber"
            routerLink="/platform/applicants"
            [queryParams]="{ createdToday: 'true' }"
          />
          <app-admin-stat-card
            title="Documents Pending"
            [value]="data.applicants.documentsPending"
            subtext="Awaiting documents"
            icon="file-text"
            tint="violet"
            routerLink="/platform/applicants"
            [queryParams]="{ statusCode: 'DOCUMENTS_PENDING' }"
          />
          <app-admin-stat-card
            title="Offers Received"
            [value]="data.applicants.offersReceived"
            subtext="Conditional + unconditional"
            icon="award"
            tint="green"
            routerLink="/platform/applicants"
            [queryParams]="{
              statusCodes: 'CONDITIONAL_OFFER_RECEIVED,UNCONDITIONAL_OFFER_RECEIVED'
            }"
          />
          <app-admin-stat-card
            title="Completed Placements"
            [value]="data.applicants.completedPlacements"
            subtext="Status: Completed"
            icon="clipboard-check"
            tint="slate"
            routerLink="/platform/applicants"
            [queryParams]="{ statusCode: 'COMPLETED' }"
          />
        </div>
      </div>
    }
  </div>

  <app-dashboard-funnel-section />

  @if (stats(); as data) {
    <div class="stat-rows">
      <div class="stat-row">
        <h2 class="stat-row__title">Tasks Assigned to Me</h2>
        <div class="stat-row__grid stat-row__grid--two">
          <app-admin-stat-card
            title="Leads"
            [value]="data.tasks.leadsAssignedToMe"
            subtext="Pending tasks on leads"
            icon="clipboard-check"
            tint="amber"
            routerLink="/platform/leads"
            [queryParams]="{ pendingTasksAssignedToMe: 'true', includeEnrolled: 'true' }"
          />
          <app-admin-stat-card
            title="Applicants"
            [value]="data.tasks.applicantsAssignedToMe"
            subtext="Pending tasks on applicants"
            icon="clipboard-check"
            tint="violet"
            routerLink="/platform/applicants"
            [queryParams]="{ pendingTasksAssignedToMe: 'true' }"
          />
        </div>
      </div>
    </div>
  }
</section>
